export default "/images/verified_user-24px.svg?2540d97d54e9a16dbe083eb2002391c0";